import script from "./StatementDetailRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementDetailRenderer.vue?vue&type=script&setup=true&lang=js"

import "./StatementDetailRenderer.vue?vue&type=style&index=0&id=2b17b086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b17b086"]])

export default __exports__